import { motion } from "framer-motion";

const COLORS = {
  green: "#00FFA3",
  yellow: "#FFD500",
  red: "#FF3366",
  blue: "#4D9FFF",
  purple: "#BD00FF",
};

export const BrutalistProgressBar = ({ label, value, color = "yellow", delay = 0, testId }) => {
  const fill = COLORS[color] || COLORS.yellow;
  return (
    <div data-testid={testId} className="w-full">
      <div className="flex items-end justify-between mb-1.5">
        <span className="text-xs sm:text-sm font-bold uppercase tracking-[0.08em] pr-2 leading-tight">
          {label}
        </span>
        <span className="font-mono2 text-lg sm:text-xl font-bold shrink-0">{value}%</span>
      </div>
      <div className="w-full h-6 sm:h-7 border-[3px] border-black rounded-full bg-white overflow-hidden">
        <motion.div
          className="h-full hazard rounded-full border-r-[3px] border-black"
          style={{ backgroundColor: fill }}
          initial={{ width: "0%" }}
          animate={{ width: `${value}%` }}
          transition={{ duration: 1.4, ease: "easeOut", delay }}
        />
      </div>
    </div>
  );
};
